export var ConfirmPageLeaveModalSubject;
(function (ConfirmPageLeaveModalSubject) {
    ConfirmPageLeaveModalSubject["ConfirmPageLeaveModal"] = "confirm-page-leave-modal";
})(ConfirmPageLeaveModalSubject || (ConfirmPageLeaveModalSubject = {}));
//# sourceMappingURL=confirm-page-leave-modal.enum.js.map